
import React from "react";

interface ProgressBarProps {
  progress: number;
  isUploading: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, isUploading }) => {
  if (!isUploading) return null;
  
  return (
    <div className="mt-2">
      <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-blue-600 rounded-full" 
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="text-sm text-center mt-1">
        Uploading... {Math.round(progress)}%
      </p>
    </div>
  );
};

export default ProgressBar;
